import { styled } from '@mui/material';
import MultiStepModal from 'ui/Modals/MultiStepModal';

export const StyMultiStepModal = styled(MultiStepModal, {
    name: 'StyMultiStepModal',
})({
    /* targets the modal card, to set a large height when we display dropdowns, to avoid double scrolling issues
     but when displaying the confirmation, we want to keep the default height otherwise there is a lot of empty space. */
    '.MuiDialog-paper:has(.MuiAutocomplete-root)': {
        height: '80vh',
    },
});
